﻿
/**
    * helpers for filtering and ranking arrays for autocomplete type functionality
    */
export class SearchUtils
{

    public static search<T>(query: string, arr: T[], valueFn: (item: T) => string, maxItems: number = 10, matchFn: (item: T) => void = null, noMatchFn: (item: T) => void = null): T[] {
        var sorted: T[] = [];

        var add = (item) => {// Insert using binary search.      
            var value = valueFn(item);          
            var score = scoreDb[value];
            var indexMin = 0;
            var indexMax = sorted.length;
            while (indexMin < indexMax) {
                var indexMid = Math.floor((indexMin + indexMax) / 2);
                var midScore = scoreDb[valueFn(sorted[indexMid])];

                //if the insert item is less than existing
                if (score > midScore) {
                    indexMax = indexMid;
                } else if (score < midScore) {
                    indexMin = indexMid + 1;
                } else { //they are equal
                    indexMin = indexMid;
                    break;
                }
            }
            sorted.splice(indexMin, 0, item);
        };

        //first get rid of duplicates
        var db = {};

        arr.forEach(item => {
            let key = valueFn(item);
            if (!key) {
                valueFn = (item: any) => {
                    // Check if item is an object and has a 'value' property
                    if (item && typeof item === 'object' && 'value' in item) {
                        return item.value; // Return the 'value' property if it exists
                    }
                    return item; // Return the item itself if no 'value' property is found
                };
                key = valueFn(item);

            }
            db[key] = item;
        });
        
        var scoreDb: { [value: string]: number } = {};
        var keys = Object.keys(db);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var score = 0;
            if (key && query) score = SearchUtils.score(key, query, 0);
            if (score > 0) {
                scoreDb[key] = score;
                add(db[key]);
                if (matchFn) matchFn(db[key]);
            } else {
                if (noMatchFn) noMatchFn(db[key]);
            }
        }
            
        if (maxItems > 0 && sorted.length >= maxItems) {
            sorted = sorted.slice(0, maxItems - 1);
        }

        return sorted;
    }
        
    /**
        * Substring matching algorithm - matches when query appears consecutively in phrase
        * Supports wildcard matching with * character
        * http://joshaven.com/string_score
        * https://github.com/joshaven/string_score
        * Scoring logic:
        * - Perfect match (exact): 1.0
        * - Substring match at start: 0.9
        * - Substring match anywhere: 0.8
        * - Wildcard match at start: 0.85
        * - Wildcard match anywhere: 0.75
        * - No match: 0
        */
    public static score(phrase: string, query: string, fuzziness: number): number {
        // If the string is equal to the word, perfect match.
        if (phrase === query) { return 1; }

        //if it's not a perfect match and is empty return 0
        if (query === "") { return 0; }

        var string = phrase,
            lString = string.toLowerCase(),
            lWord = query.toLowerCase();

        // Check for wildcard, ignore if only wildcard chars given
        if (lWord.indexOf('*') !== -1 && lWord.replace(/\*/g, '').length > 0) {
            // Split by wildcard and check if all terms exist in order ("a*c*f" turns into ["a", "c", "f"])
            var terms = lWord.split('*');
            var currentIndex = 0;
            
            for (var i = 0; i < terms.length; i++) {
                var term = terms[i];
                if (term === '') continue; // skip empty (from consecutive wildcards "**" or leading/trailing wildcards "*abc")
                
                var termIndex = lString.indexOf(term, currentIndex);
                if (termIndex === -1) {
                    // Term not found
                    return 0;
                }
                // Move current index past the found term
                currentIndex = termIndex + term.length;
            }
            
            // All terms found in order
            if (lString.indexOf(terms[0]) === 0) {
                // First term matches at start of string
                return 0.85;
            } else {
                // First term matches somewhere in the string
                return 0.75;
            }
        }

        // Check if query is a substring of phrase (case-insensitive)
        var substringIndex = lString.indexOf(lWord);
        
        if (substringIndex === -1) {
            // No match found
            return 0;
        }

        // Substring found - score based on position
        if (substringIndex === 0) {
            // Match at start of string - highest score
            return 0.9;
        } else {
            // Match somewhere in the string - still good but lower
            return 0.8;
        }
    }
        




}